import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../services/supabaseClient';
import Navbar from './Navbar';
import Footer from './Footer';
import News from './News'; 
import Calendar from './Calendar';
import Tutorials from './Tutorials';
import Support from './Support'; 
import { newsStyles as ns } from '../../styles/newsStyles';

const DashboardLayout = () => {
  const [displayName, setDisplayName] = useState('');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAccess = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();

        if (!user) {
          navigate('/login');
          return;
        }

        if (!user.user_metadata?.password_set) {
          await supabase.auth.signOut();
          navigate('/login');
          return;
        }

        const fullName = user.user_metadata?.full_name;
        if (fullName) {
          const first = fullName.split(' ')[0];
          setDisplayName(first.charAt(0).toUpperCase() + first.slice(1).toLowerCase());
        } else {
          setDisplayName(user.email?.split('@')[0]);
        }
      } catch (error) {
        console.error(error);
        navigate('/login');
      } finally {
        setLoading(false);
      }
    };

    checkAccess();
  }, [navigate]);

  const welcomeMessage = useMemo(() => {
    const hour = new Date().getHours();
    let greet = "¡Buenas noches";
    if (hour < 12) greet = "¡Buenos días";
    else if (hour < 19) greet = "¡Buenas tardes";
    return `${greet}, ${displayName || 'socio'}!`;
  }, [displayName]);

  if (loading) return null;

  return (
    <div className="flex flex-col min-h-screen bg-msc-white">
      <Navbar />
      
      <main className="flex-grow w-full max-w-[1600px] mx-auto px-4 py-8 md:py-12">
        <div className={`${ns.welcomeWrapper} mb-10 md:mb-16`}>
          <h2 className={ns.welcomeTitle}>{welcomeMessage}</h2>
          <div className={ns.welcomeSubtitleRow}>
            <span className={ns.welcomeLine}></span>
            <p className={ns.welcomeTagline}>Tu centro de apoyo operativo y novedades</p>
            <span className={ns.welcomeLine}></span>
          </div>
        </div>

        <div className="flex flex-col gap-22">
          <News />
          <Calendar />
          <Tutorials />
          <Support />
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default DashboardLayout;